export function findObjectsWithField(obj) {
    const result = [];
    function search(obj) {
        if (typeof obj === 'object' && obj !== null) {
            if (obj.hasOwnProperty('field')) {
                result.push(obj);
            }
            for (const key in obj) {
                search(obj[key]);
            }
        }
    }
    search(obj);
    return result;
}
export const filterUnusedBooleanFields = (arr) => {
    return arr.filter((item) => {
        if (item.type === 'BOOLEAN' && item.value === undefined) {
            return false;
        }
        return true;
    });
};
export const countFilterFields = (obj) => {
    const filters = filterUnusedBooleanFields(findObjectsWithField(obj.filters));
    let count = filters.length;
    // IF TYPE IS SELECTED, ADD 1 TO COUNT
    if (obj.type) {
        count++;
    }
    // IF SORT IS SELECTED, ADD 1 TO COUNT
    if (obj?.sort?.field !== undefined && obj?.sort?.direction) {
        count++;
    }
    return { totalCount: count, filterCount: filters.length };
};
export const getHumanReadableGrouping = (index) => {
    if (index.includes('service-grouping')) {
        return 'SERVICE GROUPINGS';
    }
    if (index.includes('order')) {
        return 'ORDERS';
    }
    if (index.includes('receivable')) {
        return 'RECEIVABLES';
    }
    if (index.includes('payable')) {
        return 'PAYABLES';
    }
    if (index.includes('customer')) {
        return 'CUSTOMERS';
    }
    if (index.includes('vendor')) {
        return 'VENDORS';
    }
    if (index.includes('pricing-zone')) {
        return 'PRICING ZONES';
    }
    if (index.includes('hauler-pricing-zone')) {
        return 'HAULER PRICING ZONES';
    }
    if (index.includes('lead')) {
        return 'LEADS';
    }
    if (index.includes('disposal-site')) {
        return 'DISPOSAL SITES';
    }
    if (index.includes('dumpster')) {
        return 'DUMPSTERS';
    }
    return '';
};
//# sourceMappingURL=functions.js.map